import { GlobalConf } from '../../domain/GlobalConf';

export const initialState = {
  loading: false,
  isReady: false,
  lstAvatars: [],
  sellingPoints: [],
  configuration: {} as GlobalConf,
  avatar: null,
  deviceType: ''
};

export type GlobalState = Readonly<typeof initialState>;
